import { Tr, useColorModeValue } from "@chakra-ui/react";
import { TableRowProps } from "@chakra-ui/table/dist/types/table";

import { useGetThemeColors } from "ChakraTheme";

interface IProps extends TableRowProps {
    id: string;
}

const AppointmentRowContainer = ({ children, ...restProps }: IProps) => {
  const colors = useGetThemeColors();
  const backgroundColorHover = useColorModeValue(
    colors.orange[100],
    colors.orange[500]
  );
  return (
    <Tr
      w="100%"
      _hover={{
        backgroundColor: backgroundColorHover,
        cursor: "pointer",
      }}
      {...restProps}
    >
      {children}
    </Tr>
  );
};

export { AppointmentRowContainer };
